import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const BasicModule = {
  namespaced: true,
  strict: true,
  state: {
    professions: [],
    employmentTypes: [],
    states: [],
    printOrderStates: [],
    regions: [],
    machines: [],
    distanceOrderStates: [],
    extensionOrderStates: [],
    systemSettings: {}
  },
  getters,
  actions,
  mutations
}

export default BasicModule
